import { useLocation } from "react-router-dom";

// Full-viewport animated weather sky behind the public site. Hidden on /broadcast
// so OBS chroma-key (?bg=transparent) captures stay clean.
export function Atmosphere() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/broadcast")) return null;
  return <div className="atmo-fixed" aria-hidden="true" data-testid="site-atmosphere" />;
}
